import React, { useState, useEffect } from "react";
import { Modal, Button, Col, Form, Row } from "react-bootstrap";

const AddressForm = ({ show, onHide, initial, onSave }) => {
  const [form, setForm] = useState({
    fullName: "",
    mobileNo: "",
    email: "",
    addressLine1: "",
    addressLine2: "",
    landMark: "",
    cityName: "",
    stateName: "",
    countryName: "",
    pinCode: "",
    deliveryInstruction: "",
    isPrimary: false,
  });
  const [errors, setErrors] = useState<Record<string, string>>({});

  useEffect(() => {
    if (initial) setForm({ ...form, ...initial });
  }, [initial]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const validate = () => {
    const newErrors = {};
    if (!form.fullName.trim()) newErrors.fullName = "fullName is required";
    if (!form.mobileNo.trim()) newErrors.mobileNo = "Phone number is required";
    else if (!/^\d{10}$/.test(form.mobileNo.trim())) newErrors.mobileNo = "Phone number must be exactly 10 digits";
    if (!form.addressLine1.trim()) newErrors.addressLine1 = "Address line 1 is required";
    if (!form.cityName.trim()) newErrors.cityName = "City is required";
    if (!form.stateName.trim()) newErrors.stateName = "State is required";
    if (!form.countryName.trim()) newErrors.countryName = "Country is required";
    if (!form.pinCode.trim()) newErrors.pinCode = "Pincode is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;
    onSave(form);
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered size="xl">
      <Modal.Header closeButton>
        <Modal.Title>{initial ? "Edit Address" : "Add New Address"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="g-3">
            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>Full Name</Form.Label>
                <Form.Control name="fullName" value={form.fullName} onChange={handleChange} isInvalid={!!errors.fullName}/>
                <Form.Control.Feedback type="invalid">{errors.fullName}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>Phone Number</Form.Label>
                <Form.Control name="mobileNo" value={form.mobileNo} onChange={handleChange} isInvalid={!!errors.mobileNo}/>
                <Form.Control.Feedback type="invalid">{errors.mobileNo}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>E-mail</Form.Label>
                <Form.Control name="email" value={form.email} onChange={handleChange} isInvalid={!!errors.email}/>
                <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>Address Line 1</Form.Label>
                <Form.Control name="addressLine1" value={form.addressLine1} onChange={handleChange} isInvalid={!!errors.addressLine1}/>
                <Form.Control.Feedback type="invalid">{errors.addressLine1}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>Address Line 2</Form.Label>
                <Form.Control name="addressLine2" value={form.addressLine2} onChange={handleChange}/>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>Landmark</Form.Label>
                <Form.Control name="landMark" value={form.landMark} onChange={handleChange}/>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>Delivery Instruction</Form.Label>
                <Form.Control name="deliveryInstruction" value={form.deliveryInstruction} onChange={handleChange}/>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>City</Form.Label>
                <Form.Control name="cityName" value={form.cityName} onChange={handleChange} isInvalid={!!errors.cityName}/>
                <Form.Control.Feedback type="invalid">{errors.cityName}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>State</Form.Label>
                <Form.Control name="stateName" value={form.stateName} onChange={handleChange} isInvalid={!!errors.stateName}/>
                <Form.Control.Feedback type="invalid">{errors.stateName}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>Country</Form.Label>
                <Form.Control name="countryName" value={form.countryName} onChange={handleChange} isInvalid={!!errors.countryName}/>
                <Form.Control.Feedback type="invalid">{errors.countryName}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Form.Group>
                <Form.Label>Pincode</Form.Label>
                <Form.Control name="pinCode" value={form.pinCode} onChange={handleChange} isInvalid={!!errors.pinCode}/>
                <Form.Control.Feedback type="invalid">{errors.pinCode}</Form.Control.Feedback>
              </Form.Group>
            </Col>

            <Col xs={12} md={6} lg={4}>
              <Form.Group className="h-100 d-flex align-items-end pb-2">
                <Form.Check type="checkbox" label="Set as Default Address" name="isPrimary" checked={form.isPrimary} onChange={handleChange}/>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        <Button variant="primary" onClick={handleSubmit}>Save</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddressForm;
